export const getMaxLengthErrMsg = (name: string, max: number) =>
	`${name} should not exceed ${max} characters`;

export const getMinLengthErrMsg = (name: string, max: number) =>
	`${name} should have at least ${max} characters`;

export const getMinMaxLengthErrMsg = (name: string, min: number, max: number) =>
	`'The ${name} must be between ${min} and ${max} characters'`;

export const getOnlyDigitsErrMsg = (name: string) =>
	`${name} must contain only digits`;

export const getDigitsAndDotsErrorMessage = (name: string) =>
	`${name} must contain only digits and dots as delimiters`;

export const getLettersUnderscoreErrorMessage = (name: string) =>
	`${name} must start with a letter, contain only alphanumeric characters or underscores`;

export const getLettersNumbersSpacesCommonPunctuationErrorMessage = (name: string) => {
	return `
		The ${name} must contain only alphanumeric, spaces, and common punctuation 
		(e.g., commas, periods, hyphens), no HTML or script tags allowed
	`;
};

export const getMinMaxDigitalValue = ({
	name,
	min,
	max,
}: {
	name?: string;
	min: number;
	max: number;
}) => {
	return name
		? `${name} must be within ${min} and ${max}`
		: `The value must be within ${min} and ${max}`;
};

export const getMinMaxDigitalValueErrorText = ({
	name,
	min,
	max,
}: {
	name?: string;
	min: number;
	max: number;
}) => {
	return name
		? `${name} should be between ${min} and ${max}`
		: `Value should be between ${min} and ${max}`;
};

export function mandatoryErrMessage(fieldName: string) {
	if (!fieldName) return;

	return `${fieldName} is mandatory.`;
}

export const validationErrMessages = {
	adPostCode: 'Postcode is mandatory.',
	adPropertyNoName: 'Property No./Name is mandatory.',
	adStreetName: 'Street Name is mandatory.',
	adTownCity: 'Town/City is mandatory.',
	aggregationType: 'Aggregation type is mandatory.',
	antennaModel: 'Antenna Model is mandatory.',
	apiTokenRequired: 'Api token is mandatory.',
	approvalUnit: 'Approval Units is mandatory.',
	assetHeight: 'Invalid value',
	assetId: 'Asset ID is mandatory.',
	assetType: 'Asset Type is mandatory.',
	band: 'Band is mandatory.',
	beamwidth: 'Beamwidth is mandatory.',
	cellId: 'Cell ID is mandatory.',
	channel: 'Channel is mandatory',
	code2Fa: 'Code is mandatory.',
	comment: 'Comment is mandatory.',
	configParameterInvalidValue: 'Invalid value',
	contactNumber: 'Enter a valid Contact Number',
	contactNumberFor2Fa: 'The contact number you entered is invalid or doesn\'t meet the required format',
	coords: 'Site coordinates can\'t be empty',
	country: 'Country is mandatory.',
	earfcn: 'EARFCN is mandatory.',
	earfcnInvalid: 'Invalid EARFCN value',
	easting: 'Easting is mandatory.',
	eastingValid: 'Invalid Easting',
	eastingValidLen: 'Easting should not exceed 10 characters',
	email: 'Email Address is mandatory.',
	emailUnique: 'Email must be unique',
	endDate: 'End date is mandatory',
	endRentDate: 'End date is mandatory.',
	firstName: 'First Name is mandatory.',
	frequency: 'Frequency is mandatory.',
	frequencyInvalid: 'Invalid Frequency value',
	importType: 'Import Type is mandatory.',
	jobTitle: 'Job Title is mandatory.',
	kpi: 'KPI is mandatory.',
	lastName: 'Last Name is mandatory.',
	lat: 'Latitude is mandatory.',
	latValid: 'Invalid Latitude',
	legalName: 'Legal organisation Name is mandatory.',
	lng: 'Longitude is mandatory.',
	lngValid: 'Invalid Longitude',
	logoIcon: 'Logo icon is mandatory',
	message: 'Error Code is mandatory.',
	name: 'Organisation Name is mandatory.',
	nameOranSchema: 'Yang model collection can only contain letters, digits, and special characters (_ . : -).',
	nameRequired: 'Name is mandatory.',
	nodeB: 'NodeB ID is mandatory.',
	northing: 'Northing is mandatory.',
	northingValid: 'Invalid Northing',
	northingValidLen: 'Northing should not exceed 10 characters',
	nrarfcn: 'NRARFCN is mandatory.',
	nrarfcnInvalid: 'Invalid NRARFCN value',
	organisationTelecomId: 'Organisation Telecom ID is mandatory.',
	password: 'Password is mandatory.',
	passwordMatch: 'Passwords do not match',
	phoneNumber: 'Contact Number is mandatory.',
	polygonName: 'Polygon Name is mandatory.',
	postcode: 'Postcode is mandatory.',
	presetName: 'Preset Name is mandatory.',
	price: 'Price is mandatory.',
	priceValid: 'Incorrect price',
	priority: 'Priority is mandatory.',
	projectCode: 'Project Code is mandatory.',
	projectName: 'Project Name is mandatory.',
	radius: 'Radius is mandatory.',
	recipient: 'Recipient is mandatory',
	rentalPeriodFrom: 'Rental Period From Date is mandatory.',
	rentalPeriodTo: 'Rental Period To Date is mandatory.',
	roles: 'Role is mandatory.',
	ruleName: 'Rule name is mandatory',
	setupName: 'Setup Name is mandatory',
	siteId: 'Site ID is mandatory.',
	siteType: 'Site type is mandatory.',
	startDate: 'Start date is mandatory',
	status: 'Status is mandatory.',
	technology: 'Technology is mandatory.',
	timezone: 'Timezone is mandatory.',
	title: 'Title is mandatory.',
	folderName: 'Folder Name is mandatory.',
	unitName: 'Unit Name is mandatory.',
	userName: 'User Name is mandatory.',
	validEmail: 'Email is not valid',
	vendor: 'Vendor is mandatory.',
	workflow: 'Workflow is mandatory.',
};
